import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  keywords: '',
};

export const wineSearchSlice = createSlice({
  name: 'wineSearch',
  initialState,
  reducers: {
    setWineSearchKeywords: (state, action) => {
      state.keywords = action.payload;
    },
    clearWineSearchKeywords: (state) => {
      state.keywords = '';
    }
  },
});

export const {
  setWineSearchKeywords,
  clearWineSearchKeywords,
} = wineSearchSlice.actions;

export default wineSearchSlice.reducer;